export default "__VITE_ASSET__rdn7rhvN__"